import React, { useState, useEffect } from "react";
import { AlertTriangle } from "lucide-react";

export default function MobileWarningBanner() {
  const [isMobile, setIsMobile] = useState(false);
  const [dismissed, setDismissed] = useState(false);

  useEffect(() => {
    const checkDevice = () => {
      const width = window.innerWidth;
      setIsMobile(width < 768); // Mobile & small tablets
    };

    checkDevice();
    window.addEventListener("resize", checkDevice);
    return () => window.removeEventListener("resize", checkDevice);
  }, []);

  if (!isMobile || dismissed) return null;

  return (
    <div className="mobile-warning">
      <AlertTriangle size={18} className="icon" />
      <span>
        📱 Mobile Tip: Use your wallet's built-in browser (MetaMask, Trust Wallet, etc.) for the smoothest experience. Or tap "Connect Wallet" to choose your preferred wallet app.
      </span>
      <button onClick={() => setDismissed(true)}>✕</button>
    </div>
  );
}
